import { ca } from '@cian/analytics';

export function trackShowPriceHistoryBlock() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Show',
    label: 'PriceHistoryBlock',
  });
}

export function trackSelectPriceHistoryRooms() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Select',
    label: 'PriceHistoryRooms',
  });
}
